<template>
  <BfMainFrame id="app" :class="mainFrameClassNames">
    <template v-if="!isLogin">
      <BfSideNav v-if="isDesktop" :nav-items="allowedNavItems" />
      <MobileSideNav v-else :nav-items="allowedNavItems" />
    </template>
    <router-view :key="$route.path" />
  </BfMainFrame>
</template>

<script>
import isEmpty from 'lodash.isempty';
import { mapState, mapGetters } from 'vuex';

import MobileSideNav from '@/components/MobileSideNav';
import { isDesktop, isInStandaloneMode } from '@/utils';

import navItems from './navItems';

export default {
  name: 'App',

  data() {
    return {
      navItems: navItems(),
    };
  },

  mounted() {
    if (isInStandaloneMode()) {
      document.documentElement.classList.add('-is-standalone');
    }
  },

  computed: {
    ...mapState({
      user: ({ auth }) => auth.user,
    }),

    ...mapGetters(['auth/can']),

    isLogin() {
      return this.$route.name === 'login';
    },

    isDesktop() {
      return isDesktop(this.$vssWidth);
    },

    mainFrameClassNames() {
      return {
        '-is-mobile': !this.isDesktop,
        '-is-login': this.isLogin,
      };
    },

    allowedNavItems() {
      return this.navItems.filter((item) => {
        if (item.auth && !isEmpty(item.auth.roles) && !this['auth/can'](item.auth.roles)) {
          return false;
        }

        if (item.children) {
          const children = item.children.filter((child) => {
            if (child.auth && !isEmpty(child.auth.roles) && !this['auth/can'](child.auth.roles)) {
              return false;
            }

            return child;
          });

          return { ...item, children };
        }

        return item;
      });
    },
  },

  components: {
    MobileSideNav,
  },
};
</script>

<style lang="scss" src="./styles.scss" />
